module.exports = __webpack_public_path__ + "img/newhead2.9b1397bc.png";